/* Testimonial: tre alla volta, si scorre coi pallini.

   Come funziona: la finestra e' larga esattamente tre schede e ritaglia il
   resto, quindi non puo' affacciarsi una quarta scheda tagliata. La pista
   dentro scivola con una transizione, un passo per pallino.
   Le schede restano tutte nel documento, cosi' l'altezza della sezione e'
   sempre la stessa e non sobbalza quando si cambia pagina. */
(function () {
  function avvia(giostra) {
    var finestra = giostra.querySelector('.bn-say__finestra');
    var pista = giostra.querySelector('.bn-say__pista');
    var punti = giostra.querySelector('.bn-say__punti');
    if (!finestra || !pista) return;
    var schede = Array.prototype.slice.call(pista.children);
    if (!schede.length) return;

    var indice = 0;

    function passo() {
      var s = getComputedStyle(schede[0]);
      return schede[0].getBoundingClientRect().width
           + parseFloat(s.marginLeft) + parseFloat(s.marginRight);
    }

    function perPagina() {
      var w = window.innerWidth;
      if (w >= 1220) return 3;
      if (w >= 750) return 2;
      return 1;
    }

    function ultimo() { return Math.max(0, schede.length - perPagina()); }

    function misura() {
      finestra.style.width = (passo() * perPagina()) + 'px';
    }

    function vaiA(n, animato) {
      indice = Math.min(Math.max(0, n), ultimo());
      if (animato === false) pista.style.transition = 'none';
      pista.style.transform = 'translateX(' + (-indice * passo()) + 'px)';
      if (animato === false) {
        /* forza il ricalcolo prima di riattivare l'animazione */
        void pista.offsetWidth;
        pista.style.transition = '';
      }
      schede.forEach(function (c, i) {
        var dentro = i >= indice && i < indice + perPagina();
        c.setAttribute('aria-hidden', dentro ? 'false' : 'true');
        /* fuori dalla finestra non devono essere raggiungibili col tasto Tab */
        c.querySelectorAll('a, button').forEach(function (el) {
          el.tabIndex = dentro ? 0 : -1;
        });
      });
      if (punti) {
        Array.prototype.forEach.call(punti.children, function (b, i) {
          b.setAttribute('aria-selected', i === indice ? 'true' : 'false');
        });
      }
    }

    function costruisciPunti() {
      if (!punti) return;
      var quanti = ultimo() + 1;
      punti.innerHTML = '';
      if (quanti < 2) return;
      for (var i = 0; i < quanti; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'bn-say__punto';
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-label', 'Testimonianza ' + (i + 1) + ' di ' + schede.length);
        b.dataset.indice = i;
        punti.appendChild(b);
      }
    }

    if (punti) {
      punti.addEventListener('click', function (e) {
        var b = e.target.closest('.bn-say__punto');
        if (b) vaiA(parseInt(b.dataset.indice, 10), true);
      });
      punti.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { vaiA(indice + 1, true); e.preventDefault(); }
        if (e.key === 'ArrowLeft')  { vaiA(indice - 1, true); e.preventDefault(); }
      });
    }

    /* strisciata col dito */
    var x0 = null;
    pista.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    pista.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var d = e.changedTouches[0].clientX - x0;
      if (Math.abs(d) > 45) vaiA(indice + (d < 0 ? 1 : -1), true);
      x0 = null;
    }, { passive: true });

    var r;
    window.addEventListener('resize', function () {
      clearTimeout(r);
      r = setTimeout(function () {
        misura();
        costruisciPunti();
        vaiA(Math.min(indice, ultimo()), false);
      }, 150);
    });

    misura();
    costruisciPunti();
    vaiA(0, false);

    /* le immagini possono cambiare la larghezza delle schede quando arrivano */
    window.addEventListener('load', function () { misura(); vaiA(indice, false); });
  }

  function inizia() { document.querySelectorAll('[data-bn-carosello]').forEach(avvia); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inizia);
  else inizia();
})();
